module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-盛泰客户.50f0f49a.png";